import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from '@repo/ui';
import { useTranslation } from 'react-i18next';
import noAvailableOffers from '@repo/assets/images/no-available-offers.svg?url';
import type { PromotionCodeErrorType } from '@repo/shared/types';

import { useModalStore } from '@/components/modal/modal.store';

export function PromotionCodeErrorModalContent() {
  const { t } = useTranslation();
  const { closeModal, additionalProps } = useModalStore();

  const errorType = additionalProps.errorType as PromotionCodeErrorType | undefined;
  const amount = additionalProps.amount as string | undefined;

  if (!errorType) return null;

  const handleClose = () => {
    (additionalProps.onClose as (() => void) | undefined)?.();
    closeModal();
  };

  return (
    <Box>
      <Typography component="p" marginBottom={3} textAlign="center" variant="h4" fontWeight="bold">
        {t(`promotionCode.errors.${errorType}.title`, { amount })}
      </Typography>
      <Box display="flex" justifyContent="center" alignItems="center" marginBottom={5}>
        <Box component="img" src={noAvailableOffers} />
      </Box>
      <Typography textAlign="center" marginBottom={6}>
        {t(`promotionCode.errors.${errorType}.description`, { amount })}
      </Typography>
      <Box display="flex" justifyContent="center">
        <Button color="info" size="large" variant="contained" onClick={handleClose}>
          {t('promotionCode.errorModal.closeButton')}
        </Button>
      </Box>
    </Box>
  );
}
